import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NthPipe } from './nth.pipe';



@NgModule({
  declarations: [
    NthPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NthPipe,
  ]
})
export class NthModule { }
